import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "./Spinner";
import OverlayLoader from "../modalPopups/overlayLoader";

export default function DigitalReportsLinkSection(props) {
  const navigate = useNavigate();

  const apiDigitalReportsLink = `${process.env.REACT_APP_CSAPI_BASE_URL}/direct-reports-link`;

  const accessToken = localStorage.getItem("accessToken");

  const [dPLData, setDPLData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [overLayPopupShow, setOverLayPopupShow] = useState(false);
  const [overLayPopupText, setOverLayPopupText] = useState("");

  const [result, setResult] = useState("");

  const handleOverylayModalShowClose = (modalStatus, modalText) => {
    setOverLayPopupShow(modalStatus);
    setOverLayPopupText(modalText);
  };

  // Call All Links
  const GetSearchResult = (URl) => {
    axios
      .get(URl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((result) => {
        setIsLoading(false);
        handleOverylayModalShowClose(false, "");

        if (result.data.status === "success") {
          setDPLData(result.data.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  const copyToClipboard = (getVal) => {
    navigator.clipboard.writeText(getVal).then(
      () => {
        setResult("Link Copied");
        setTimeout(() => {
          setResult("");
        }, 2000);
      },
      (err) => console.error("Could not copy text: ", err)
    );
  };

  useEffect(() => {
    setIsLoading(true);
    setResult("");
    handleOverylayModalShowClose(
      true,
      "Digital Report Links Loading... Please Wait"
    );
    GetSearchResult(apiDigitalReportsLink); // eslint-disable-next-line
  }, [props.getDate]);

  return (
    <>
      <div className="app-wrapper">
        <OverlayLoader
          show={overLayPopupShow}
          title=""
          body={overLayPopupText}
        />

        <div className="row d-flex justify-content-center pt-3">
          <div className="col-md-10">
            <div className="card p-3 py-4">
              <h5>Digital Report Links</h5>
              {result && <h6 className="text-success fw-bold">{result}</h6>}
              <div className="row">
                {isLoading ? (
                  <LoadingSpinner loadingText="Fetching Links..." />
                ) : (
                  ""
                )}
                {dPLData
                  .sort((a, b) => {
                    const nameA = a.name ? a.name.toString().toLowerCase() : "";
                    const nameB = b.name ? b.name.toString().toLowerCase() : "";
                    return nameA.localeCompare(nameB);
                  })
                  .map((element, i) => {
                    return (
                      <div className="input-group mt-1 " key={i}>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control bg-secondary text-white"
                            readOnly
                            value={element.name}
                          />
                        </div>
                        <div className="col-md-2">
                          <button
                            className="btn btn-light-primary"
                            onClick={() => copyToClipboard(`${element.url}`)}
                          >
                            Copy Link
                          </button>
                        </div>
                      </div>
                    );
                  })}

                {dPLData.length === 0 && !isLoading && (
                  <div className="alert alert-danger fade show mt-3">
                    Digital Report Links Not Available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
